import { DEFAULT_NA } from './newrelic-constants';
import { getOriginAndDestinarionAirports, getCookie } from '../helpers';

export function getEnvironmentMicro() {
  return isProdEnviroment() ? 'PROD' : 'CERT';
}

/**
 * Utilities Functions
 **/
function isProdEnviroment() {
  const env = location.hostname;
  return /^(www.)*(aeromexico)\.com$/gi.test(env);
}

export function getLastName(globalState) {
  return globalState?.dataPnrToLoad?.lastName || DEFAULT_NA;
}

export function getLegEntity(globalState) {
  return globalState?.pnrInfo?.globalMarketFlight || DEFAULT_NA;
}

export function getLegRegion(globalState) {
  return globalState?.pnrInfo?.legCollection?.[0]?.legRegion || DEFAULT_NA;
}

export function getOD(globalState) {
  const airports = getOriginAndDestinarionAirports(globalState.pnrInfo);
  const originAirport = airports?.origin || DEFAULT_NA;
  const destinationAirport = airports?.destination || DEFAULT_NA;

  return originAirport === DEFAULT_NA && destinationAirport === DEFAULT_NA ? DEFAULT_NA : `${ originAirport }-${ destinationAirport }`;
}

export function getPNR(globalState) {
  return globalState?.dataPnrToLoad?.pnr || DEFAULT_NA;
}

export function getStorefront(globalState) {
  const storefrontFromManage = globalState?.Manage?.storefront || DEFAULT_NA;
  const fallbackStorefront = globalState?.storefront || DEFAULT_NA;
  const storefront = storefrontFromManage !== DEFAULT_NA ? storefrontFromManage : fallbackStorefront;

  return storefront;
}

export function getTierAMR(globalState) {
  return globalState?.allPassengers?._collection?.[0]?.ManageUserProfileAccount?.account?.tier || DEFAULT_NA;
}

export function getTripType(globalState) {
  return globalState?.pnrInfo?.flightItineraryType || DEFAULT_NA;
}

export function getFfnAMR() {
  const ffn = JSON.parse(getCookie('userSession')).ffNumber || DEFAULT_NA;
  return  ffn;
}